import React, { lazy } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./Routers/RootRoutes";

const App = () => {
  return (
    <RouterProvider router={router} />
  );
};

export default App;
